<template>
    <multi-file-upload
            :max-cnt="12"
            :max-size="10"
            :files="wtprOrgFiles"
            @change="wtprFlUpld_change"
            @delete="wtprFlUpld_delete"/>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'업로드'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
</template>

<script setup>
import {ref, defineProps, defineEmits} from "vue";
import {getUtils} from "@/utils/import";
const {$alert} = getUtils();

const props = defineProps({
  pdfFiles: {
    type: Array,
    required: false,
    default: () => []
  }
})
const emits = defineEmits(['rgst', 'close']);

const wtprOrgFiles = ref(props.pdfFiles);
const wtprFls = ref([]);
const dlts = ref([]);

const wtprFlUpld_change = async (fileInfos) => {
  wtprFls.value = wtprFls.value.concat(fileInfos);
}

const wtprFlUpld_delete = async ({se, index}) => {
  if (se == 'old') {
    let fileSn = wtprOrgFiles.value[index].fileSn;
    dlts.value.push(fileSn);
    wtprOrgFiles.value.splice(index, 1);
  } else {
    wtprFls.value.splice(index, 1);
  }
}

const btnCancl_click = () => {
  $alert('과거 신고자료를 제출하여, 당해 연도에 신고한 원천세 신고자료에 대한 오류검증을 진행합니다. <br /><br /> 다음에 하실 경우에는 포털 > 시설/서비스 > 서비스신청내역 > [과거세무신고자료]에서 제출 가능합니다.')
  emits('close');
}

const btnRgst_click = () => {
  emits('rgst', wtprOrgFiles.value.concat(wtprFls.value), dlts.value);
  emits('close');
}
</script>

<style scoped>

</style>
